import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { CommonService } from '@common/services/common.service';

@Component({
    selector: 'app-operational-plan-approvals-history-segment',
    templateUrl: './operational-plan-approvals-history-segment.component.html',
    styleUrls: ['./operational-plan-approvals-history-segment.component.scss'],
    providers: [CommonService]
})
export class OperationalPlanApprovalsHistorySegment implements OnInit {
    @Input() model: any;

    ngOnInit(): void {
        
    }  

    get agencyApprovedByFullName(): string {
        return this.model.operationalPlans?.length > 0
            ? this.model.operationalPlans[0]?.agencyApprovedBy?.fullName
            : null;
    }

    get agencyApprovalDate(): Date | null {
        return this.model.operationalPlans?.length > 0
            ? this.model.operationalPlans[0]?.agencyApprovalDate
            : null;
    }

    set agencyApprovalDate(value: Date | null) {
        if (this.model.operationalPlans?.length > 0) {
            this.model.operationalPlans[0].agencyApprovalDate = value;
        } 
    }

    get dispatchApprovedByFullName(): string {
        return this.model.operationalPlans?.length > 0
            ? this.model.operationalPlans[0]?.dispatchApprovedBy?.fullName
            : null;
    }

    get dispatchApprovalDate(): Date | null {
        return this.model.operationalPlans?.length > 0
            ? this.model.operationalPlans[0]?.dispatchApprovalDate
            : null;
    }

    set dispatchApprovalDate(value: Date | null) {
        if (this.model.operationalPlans?.length > 0) {
            this.model.operationalPlans[0].dispatchApprovalDate = value;
        } 
    }

    get dispatchShiftApprovedByFullName(): string {
        return this.model.operationalPlans?.length > 0
            ? this.model.operationalPlans[0]?.dispatchShiftApprovedBy?.fullName
            : null;
    }

    get dispatchShiftApprovalDate(): Date | null {
        return this.model.operationalPlans?.length > 0
            ? this.model.operationalPlans[0]?.dispatchShiftApprovalDate
            : null;
    }

    set dispatchShiftApprovalDate(value: Date | null) {
        if (this.model.operationalPlans?.length > 0) {
            this.model.operationalPlans[0].dispatchShiftApprovalDate = value;
        } 
    }
}
